// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>12</span>&nbsp;&nbsp;I know that the Lord will bring justice for the oppressed&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and maintain the cause of the needy.<br> </p> </div></div>";
// Exports
module.exports = code;